<template>
  <div class="ty-main">
    <div class="ty-tabs">
      <template v-for="(item, index) in tabs">
        <div
          class="tab-item"
          :key="index"
          :class="{ active: tabindex === index }"
          @click="tabclick(index)"
        >
          {{ item.title }}
        </div>
      </template>
    </div>
    <Employees v-if="tabindex === 0" @staffId="staffId" @status="status" @staffName="staffName"></Employees>
    <Sensitivity v-if="tabindex === 1" :staffId="staff_id" :statu="statu" :name="name"></Sensitivity>
  </div>
</template>
<script>
import Sensitivity from './components/sensitivity'
import Employees from './components/employees'
export default {
  components: {
    Sensitivity,
    Employees
  },
  data() {
    return {
      tabs: [
        {
          title: '员工禁用操作'
        },
        {
          title: '删除客户操作'
        }
      ],
      tabindex: 0,
      staff_id: '',
      statu: '',
      name: ''
    }
  },
  mounted() {
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    staffId(date) {
      this.staff_id = date
      if (this.staff_id !== '') {
        this.tabindex = 1
      }
    },
    status(date) {
      this.statu = date
    },
    staffName(date) {
      this.name = date
    },
    tabclick(index) {
      this.staff_id = ''
      this.statu = ''
      this.name = ''
      if (index !== this.tabindex) {
        this.tabindex = index
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ty-tabs .tab-item{
  width: 120px;
}
.ty-tabs .tab-item.active::before {
  content: '';
  position: absolute;
  top: 77px;
  left: 0;
  width: 120px;
  height: 3px;
  background: #204a9e;
  border-radius: 3px 3px 0px 0px;
}
::v-deep .ty-tabs .tab-item{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #303133;
  margin-left: 20px;
}
::v-deep .ty-tabs .tab-item:hover{
  color: #204A9E;
}
::v-deep .ty-tabs .tab-item.active{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 550;
  color: #204A9E;
}
::v-deep .el-dialog__title {
  line-height: 22px;
}
</style>
